'use strict';
import sxQuery from '../../sxQuery/sxQuery';
import DefaultConfig from '../configuration/DefaultConfig';
import ThemeColorBuilder from './ThemeColorBuilder';
import SxQueryUtils from '../../sxQuery/SxQueryUtils';
import LayoutType from '../enums/LayoutType';
const Styles = {
    renderDefaultStyles(pluginConfiguration, layerId, postfix = '') {
        const $target = pluginConfiguration.style.targetNode ? sxQuery(pluginConfiguration.style.targetNode) : sxQuery(document);
        const stylesToAppend = [];
        const $appendTarget = $target.find('head').length > 0 ? $target.find('head') : $target;
        $target.find('#ss360-default-css').remove();
        try {
            // eslint-disable-next-line
            const css = require('../../../sass/siteSearch/main.scss'); // load the default css
            stylesToAppend.push({
                css: `<style id='ss360-default-css' type="text/css">${css}</style>`,
                target: $appendTarget
            });
        }
        catch (err) {
            console.error(err);
            const href = 'https://cdn.sitesearch360.com/v15/sitesearch360-v15.min.css';
            stylesToAppend.push({
                css: '<style id="ss360-default-css"></style>',
                target: $appendTarget
            });
            SxQueryUtils.get(href, (data) => {
                $target.find('#ss360-default-css').text(data);
            }, () => {
                $target.find('#ss360-default-css').remove();
                stylesToAppend.push({ css: `<link rel="stylesheet" id="ss360-default-css" href="${href}"></link>`, target: $appendTarget });
            });
        }
        const styleSettings = pluginConfiguration.style;
        const mobileLayout = pluginConfiguration.layout.mobile;
        const desktopLayout = pluginConfiguration.layout.desktop;
        // Grid
        let innerStyle = '';
        const { showListGridToggle } = pluginConfiguration.layout;
        const isMobileGrid = mobileLayout.type === LayoutType.Grid || mobileLayout.type === LayoutType.Mixed;
        const isDesktopGrid = desktopLayout.type === LayoutType.Grid || desktopLayout.type === LayoutType.Mixed;
        if (isMobileGrid || isDesktopGrid || showListGridToggle) {
            const overridenGridStyles = [];
            const colSm = Math.min(mobileLayout.gridColsSm || 1, 10);
            const colMd = Math.min(mobileLayout.gridColsMd || 2, 10);
            const colLg = Math.min(desktopLayout.gridColsLg || 3, 10);
            const colXl = Math.min(desktopLayout.gridColsXl || 4, 10);
            // eslint-disable-next-line max-len
            const extraFlex = '@media (#M_QUERY#){.ss360-grid--#SZ#{-ms-grid-columns:#COLS#;grid-template-columns:#COLS#;}.ss360-grid--#SZ# .ss360-suggests__header{min-height: #MIN_HEIGHT#}.ss360-grid--#SZ# .ss360-similar-content-block,.ss360-grid--#SZ# .ss360-suggests--assistant{grid-column-start: span #COL_COUNT#;}}';
            const buildColEntry = (mediaQuery, size, cols) => {
                const minHeight = cols === 1 ? '0' : 'calc(var(--ss360-fs-md) * 2 * 1.2);';
                return extraFlex.replace('#M_QUERY#', mediaQuery).replace(/#SZ#/g, size).replace(/#COLS#/g, new Array(cols + 1).join('1fr ').trim()).replace('#MIN_HEIGHT#', minHeight).replace(/#COL_COUNT#/g, `${cols}`);
            };
            if (isMobileGrid || showListGridToggle) {
                let isMdOverriden = false;
                if (colMd !== 2) {
                    isMdOverriden = true;
                    overridenGridStyles.push(buildColEntry('max-width: 991px', 'sm', colMd));
                }
                if (colSm !== 1 || isMdOverriden) {
                    overridenGridStyles.push(buildColEntry('max-width: 767px', 'sm', colSm));
                }
            }
            if (isDesktopGrid || showListGridToggle) {
                let isLgOverriden = false;
                if (colLg !== 3) {
                    isLgOverriden = true;
                    overridenGridStyles.push(buildColEntry('min-width: 992px', 'lg', colLg));
                }
                if (colXl !== 4 || isLgOverriden) {
                    overridenGridStyles.push(buildColEntry('min-width: 1200px', 'lg', colXl));
                }
            }
            innerStyle += overridenGridStyles.join('');
        }
        // theme color
        if (styleSettings.themeColor !== DefaultConfig.style.themeColor || styleSettings.accentColor !== DefaultConfig.style.accentColor) {
            const themeColor = styleSettings.themeColor;
            const themeColorId = `ss360-theme-color${postfix ? `--${postfix}` : ''}`;
            $target.find(`#${themeColorId}`).remove();
            const $bodyTarget = $target.find('body').length > 0 ? $target.find('body') : $target;
            stylesToAppend.push({ css: `<style id="${themeColorId}">${ThemeColorBuilder(themeColor, styleSettings.accentColor, `#${layerId}`).build()}</style>`, target: $bodyTarget });
        }
        if (styleSettings.additionalCss) {
            innerStyle += styleSettings.additionalCss;
        }
        if (pluginConfiguration.queryTerm.highlightColor !== DefaultConfig.queryTerm.highlightColor) {
            innerStyle += `.ss360-layer{--ss360-highlight-color: ${pluginConfiguration.queryTerm.highlightColor}}`;
        }
        if (innerStyle !== '') {
            const customCssId = `ss360-custom-css${postfix ? `--${postfix}` : ''}`;
            $target.find(`#${customCssId}`).remove();
            stylesToAppend.push({ css: `<style id="${customCssId}">${innerStyle}</style>`, target: $appendTarget });
        }
        if (pluginConfiguration.searchSource === 'ZOE') {
            stylesToAppend.push({
                css: '<style id="ss360-immersive-drawers">.ss360-u-hide-y-overflow {overflow-y: hidden;}</style>',
                target: sxQuery('body')
            });
        }
        SxQueryUtils.requestAnimationFrame(() => {
            stylesToAppend.forEach((style) => {
                (style.target || $appendTarget).append(style.css);
            });
        });
    }
};
export default Styles;
